"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCreativeVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="138671" id="beyond-the-ledger" className="bg-primary-500 text-primary-foreground py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 xl:gap-20 items-center">
          <div className="relative overflow-hidden rounded-2xl shadow-xl border border-white/10 bg-primary-700 group order-2 lg:order-1">
            <div className="aspect-[4/3] overflow-hidden">
              <img src="https://stable-woodcock.10web.cloud/wp-content/uploads/2026/04/ChatGPT-Image-Apr-21-2026-11_06_21-AM.png" alt="Northern advisory and community development work" className="w-full h-full object-cover object-center transition-transform duration-1000 ease-out group-hover:scale-105" loading="lazy" />
            </div>

            <div className="absolute inset-0 bg-primary-900/20 mix-blend-multiply pointer-events-none" />

            <div className="absolute inset-0 opacity-15 mix-blend-overlay pointer-events-none" style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
          }} />
          </div>

          <div ref={ref} className={`relative transition-all duration-1000 transform order-1 lg:order-2 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="absolute -right-4 -bottom-16 text-[10rem] md:text-[16rem] font-default font-bold text-white/[0.04] leading-none select-none pointer-events-none tracking-tighter">
              01
            </div>

            <div className="relative z-10 max-w-xl">
              <div className="flex items-center gap-4 mb-6">
                <div className="h-[1px] w-12 bg-secondary" />
                <span className="text-secondary font-default text-sm tracking-widest uppercase font-bold">
                  Strategic Advisory
                </span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold mb-6 text-white leading-tight">
                Beyond the Ledger
              </h2>

              <p className="text-primary-foreground/90 text-base md:text-lg mb-8 leading-relaxed font-default">
                Our expertise extends into governance, community development,
                and systems support, helping organizations build robust
                frameworks for long-term growth and stability across Northern
                Ontario.
              </p>

              <Button asChild variant="outline" size="lg" className="h-12 px-8 rounded-md border-white/70 text-white hover:bg-white hover:text-primary-500 font-default bg-transparent">
                <Link to="/services">
                  Learn More
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}